/**
 * Limpia `sessionStorage` y entradas de `localStorage` propias del dashboard al cerrar sesión.
 * Evita dejar tokens de invitación, casa activa, preferencias de flujo o datos en caché local.
 */
export function clearDashboardBrowserStorage(): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.clear();
  } catch {
    /* private mode / unavailable */
  }
  try {
    const explicit = [
      "home_expense_dashboard_locale",
      "homeexpense:activeHouseId",
      "he_expense_last_create_flow",
    ] as const;
    for (const key of explicit) {
      window.localStorage.removeItem(key);
    }
    const extra: string[] = [];
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      if (!key) continue;
      if (
        key.startsWith("homeexpense:") ||
        key.startsWith("home_expense_") ||
        key.startsWith("he_") ||
        key.startsWith("@homeexpense/")
      ) {
        extra.push(key);
      }
    }
    for (const key of extra) {
      window.localStorage.removeItem(key);
    }
  } catch {
    /* private mode / unavailable */
  }
}
